import { render, staticRenderFns } from "./LogOutHandler.vue?vue&type=template&id=45cdbbb6&"
import script from "./LogOutHandler.vue?vue&type=script&lang=js&"
export * from "./LogOutHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\websites\\newshop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45cdbbb6')) {
      api.createRecord('45cdbbb6', component.options)
    } else {
      api.reload('45cdbbb6', component.options)
    }
    module.hot.accept("./LogOutHandler.vue?vue&type=template&id=45cdbbb6&", function () {
      api.rerender('45cdbbb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/LogOutHandler.vue"
export default component.exports